/* Scoped progressive enhancement; product references remain usable without JS. */
(() => {
  const cleanProperties = properties => Object.fromEntries(Object.entries(properties || {}).filter(([, v]) => v !== '' && v != null).map(([k, v]) => [k, String(v)]).sort(([a], [b]) => a.localeCompare(b)));
  const isUpload = value => value && typeof value === 'object' && typeof value.arrayBuffer === 'function';
  const lineQuantity = (cart, item) => {
    const uploads = new Set(Object.keys(item.properties || {}).filter(key => isUpload(item.properties[key])));
    const comparable = properties => cleanProperties(Object.fromEntries(Object.entries(properties || {}).filter(([key]) => !uploads.has(key))));
    return (cart.items || []).filter(line => String(line.variant_id || line.id) === String(item.id) && String(line.selling_plan_allocation?.selling_plan?.id || '') === String(item.selling_plan || '') && JSON.stringify(comparable(line.properties)) === JSON.stringify(comparable(item.properties))).reduce((sum, line) => sum + line.quantity, 0);
  };
  function mainEntry(form) {
    const id = Number(form.get('id')), quantity = Number(form.get('quantity') || 1), properties = {};
    if (!Number.isSafeInteger(id) || id < 1 || !Number.isSafeInteger(quantity) || quantity < 1) throw new Error('Please check the product option and quantity.');
    form.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && (!isUpload(value) || value.size)) properties[match[1]] = value;
    });
    return { quantity, variant: { id, properties, gift: Number(properties._gwp_variant_id) || null, selling_plan: form.get('selling_plan') || null } };
  }
  function batchFormData(items, sections) {
    const form = new FormData();
    items.forEach((item, index) => {
      form.append(`items[${index}][id]`, String(item.id)); form.append(`items[${index}][quantity]`, String(item.quantity));
      if (item.selling_plan) form.append(`items[${index}][selling_plan]`, String(item.selling_plan));
      Object.entries(item.properties || {}).forEach(([key, value]) => { if (value != null && value !== '') form.append(`items[${index}][properties][${key}]`, value); });
    });
    form.append('sections', sections.join(',')); form.append('sections_url', window.location.pathname); return form;
  }
  const confirmedLines = (before, after, items) => items.filter(item => lineQuantity(after, item) >= lineQuantity(before, item) + item.quantity);
  function buildItems(entries, giftHelper, now = Date.now()) {
    return entries.flatMap(entry => {
      const properties = { ...entry.variant.properties };
      const gift = entry.variant.gift && String(entry.variant.gift) !== String(entry.variant.id) && (!entry.variant.giftEnd || entry.variant.giftEnd * 1000 > now) ? entry.variant.gift : null;
      if (gift) properties._gwp_variant_id = String(gift);
      const item = { id: entry.variant.id, quantity: entry.quantity || 1, properties };
      if (entry.variant.selling_plan) item.selling_plan = entry.variant.selling_plan;
      if (!gift) return [item];
      if (giftHelper) {
        const form = new FormData();
        form.set('id', String(item.id)); form.set('quantity', String(item.quantity));
        if (item.selling_plan) form.set('selling_plan', String(item.selling_plan));
        Object.entries(properties).forEach(([key, value]) => form.set(`properties[${key}]`, value));
        const expanded = giftHelper(form);
        if (expanded.has('items[0][id]')) {
          const result = [];
          for (let index = 0; expanded.has(`items[${index}][id]`); index++) {
            const props = {};
            expanded.forEach((value, key) => {
              const match = key.match(new RegExp(`^items\\[${index}\\]\\[properties\\]\\[(.+)\\]$`));
              if (match) props[match[1]] = value;
            });
            result.push({ ...(expanded.get(`items[${index}][selling_plan]`) ? { selling_plan: expanded.get(`items[${index}][selling_plan]`) } : {}), id: Number(expanded.get(`items[${index}][id]`)), quantity: Number(expanded.get(`items[${index}][quantity]`)) || 1, properties: props });
          }
          return result;
        }
      }
      // Same contract as KaGwpCart when app.js has not registered yet.
      return [item, { id: gift, quantity: item.quantity, properties: { _gwp: 'true', _gwp_parent_variant_id: String(item.id) } }];
    });
  }
  function isCoreAdd(detail, variantIds) {
    if (!detail || (detail.source !== 'product-form' && !(detail.source === 'complete-your-system' && detail.coreProductAdded))) return false;
    const id = String(detail.productVariantId || detail.product?.variant_id || detail.product?.id || '');
    return !!id && (variantIds || '').split(',').includes(id);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { cleanProperties, lineQuantity, confirmedLines, buildItems, mainEntry, isCoreAdd };
  if (typeof window === 'undefined' || customElements.get('ka-complete-system')) return;
  const instances = new Set();
  const matchesCoreAdd = (instance, detail) => isCoreAdd(detail, instance.dataset.variantIds);
  let cartBusy = false;
  class CompleteSystem extends HTMLElement {
    connectedCallback() {
      this.sourceSection ||= this.closest('.section-complete-system');
      const placement = [...document.querySelectorAll('[data-system-placement]')].find(el => el.dataset.systemProductId === this.dataset.systemProductId);
      if (placement && this.parentElement !== placement) {
        placement.querySelectorAll('ka-complete-system').forEach(old => { old.suppressRestore = true; old.remove(); });
        this.classList.add('ka-system--inline'); placement.append(this); return;
      }
      if (this.controller) return;
      this.selection = new Set(); this.cards = new Map(); this.panels = [...this.querySelectorAll('[data-system-panel]')];
      this.addButton = this.querySelector('[data-system-add]');
      try {
        this.querySelectorAll('[data-system-card]').forEach(card => {
          const variants = JSON.parse(card.querySelector('[data-system-variants]').content.textContent);
          if (!variants.length || !variants.every(v => Number.isSafeInteger(v.id) && v.id > 0 && Number.isSafeInteger(v.price) && v.price >= 0)) throw new Error('Invalid accessory data');
          const id = card.dataset.productId;
          this.cards.set(id, { id, title: card.dataset.productTitle, card, variants, variant: variants.find(v => String(v.id) === card.dataset.initialVariant) || null });
        });
        if (!this.cards.size) return;
        this.dialog = this.querySelector('[data-system-dialog]');
        if (typeof this.dialog?.showModal !== 'function') return;
        this.controller = new AbortController();
        this.addEventListener('click', event => this.click(event), { signal: this.controller.signal });
        this.addEventListener('change', event => this.change(event), { signal: this.controller.signal });
        this.addEventListener('keydown', event => this.keydown(event), { signal: this.controller.signal });
        const tabs = this.querySelector('[data-system-tabs]'); tabs.replaceChildren();
        this.tabs = this.panels.map((panel, index) => {
          const tab = document.createElement('button'); tab.type = 'button'; tab.className = 'ka-system__tab';
          tab.id = `${panel.id}-tab`; tab.dataset.systemTab = String(index); tab.setAttribute('role', 'tab'); tab.setAttribute('aria-controls', panel.id);
          tab.append(document.createTextNode(panel.dataset.categoryName));
          const count = document.createElement('span'); count.className = 'ka-system__count'; count.dataset.systemCount = ''; count.hidden = true; tab.append(count); tabs.append(tab);
          panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', tab.id); panel.tabIndex = 0;
          return tab;
        });
        tabs.setAttribute('role', 'tablist'); tabs.hidden = this.tabs.length <= 1;
        this.querySelectorAll('[data-system-enhancement],[data-system-summary]').forEach(el => { el.hidden = false; });
        this.picker = this.querySelector('[data-system-picker]');
        this.fallback = this.querySelector('[data-system-fallback]');
        this.dialog.append(this.picker); this.fallback.hidden = true;
        this.querySelectorAll('[data-system-open]').forEach(button => { button.hidden = false; });
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.closeModal(); }, { signal: this.controller.signal });
        this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.releaseModal(); }, { signal: this.controller.signal });
        this.classList.add('ka-system--ready'); instances.add(this);
        this.activate(0); this.cards.forEach(entry => this.updateCard(entry)); this.update(); this.tick();
      } catch (_) {
        this.closeModal(false);
        if (this.picker && this.fallback) { this.fallback.append(this.picker); this.fallback.hidden = false; }
        this.querySelectorAll('[data-system-open]').forEach(button => { button.hidden = true; });
        this.controller?.abort(); this.controller = null;
        this.panels.forEach(panel => { panel.hidden = false; });
        this.querySelectorAll('[data-system-enhancement],[data-system-summary],[data-system-tabs]').forEach(el => { el.hidden = true; });
        this.classList.remove('ka-system--ready'); instances.delete(this);
      }
    }
    disconnectedCallback() {
      this.closeModal(false);
      this.controller?.abort(); this.controller = null; clearTimeout(this.timer); instances.delete(this);
      if (!this.suppressRestore && !this.isConnected && this.sourceSection?.isConnected) {
        queueMicrotask(() => { if (!this.isConnected && this.sourceSection?.isConnected) this.sourceSection.append(this); });
      }
    }
    openModal() {
      if (!this.dialog || this.dialog.open) return;
      this.returnFocus = document.activeElement;
      const root = document.documentElement;
      this.scrollStyles = { overflow: root.style.overflow, gutter: root.style.scrollbarGutter };
      if (window.innerWidth > root.clientWidth) root.style.scrollbarGutter = 'stable';
      root.style.overflow = 'hidden';
      try { this.dialog.showModal(); this.querySelector('[data-system-close]').focus({ preventScroll: true }); }
      catch (_) { this.releaseModal(); }
    }
    releaseModal() {
      if (!this.scrollStyles) return;
      document.documentElement.style.overflow = this.scrollStyles.overflow;
      document.documentElement.style.scrollbarGutter = this.scrollStyles.gutter;
      this.scrollStyles = null;
    }
    closeModal(restoreFocus = true) {
      if (!this.dialog?.open) return;
      const showCart = restoreFocus && this.afterCoreAdd; this.afterCoreAdd = false;
      this.dialog.close(); this.releaseModal();
      if (showCart && typeof document.getElementById('Cart-Drawer')?.open === 'function') { document.getElementById('Cart-Drawer').open(); return; }
      if (restoreFocus && this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }
    money(cents) {
      const currency = this.dataset.currency || window.Shopify?.currency?.active || 'AUD';
      try { return new Intl.NumberFormat(currency === 'AUD' ? 'en-AU' : (document.documentElement.lang || 'en'), { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
      catch (_) { return (cents / 100).toFixed(2); }
    }
    plain(text) { return new DOMParser().parseFromString(String(text), 'text/html').body.textContent; }
    activate(index, focus = false) {
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; this.tabs[i].setAttribute('aria-selected', String(i === index)); this.tabs[i].tabIndex = i === index ? 0 : -1; });
      if (focus) {
        const tab = this.tabs[index], strip = tab.parentElement;
        const rect = tab.getBoundingClientRect(), bounds = strip.getBoundingClientRect();
        if (rect.left < bounds.left) strip.scrollLeft -= bounds.left - rect.left;
        else if (rect.right > bounds.right) strip.scrollLeft += rect.right - bounds.right;
        tab.focus({ preventScroll: true });
      }
    }
    keydown(event) {
      if (this.dialog?.open && this.afterCoreAdd && event.key === 'Escape') {
        // The cart drawer also closes on document keyup; let this Escape dismiss only the upsell.
        document.addEventListener('keyup', keyup => { if (keyup.key === 'Escape') keyup.stopImmediatePropagation(); }, { capture: true, once: true, signal: this.controller.signal });
      }
      if (this.dialog?.open && event.key === 'Tab') {
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]):not([tabindex="-1"]),a[href],input:not([disabled]),select:not([disabled]),[tabindex="0"]')].filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) { event.preventDefault(); first?.focus(); }
        return;
      }
      const tab = event.target.closest('[data-system-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault(); const current = Number(tab.dataset.systemTab); const length = this.tabs.length;
      this.activate(event.key === 'Home' ? 0 : event.key === 'End' ? length - 1 : (current + (event.key === 'ArrowRight' ? 1 : -1) + length) % length, true);
    }
    click(event) {
      const opener = event.target.closest('[data-system-open]');
      if (opener) {
        const index = this.panels.findIndex(panel => panel.dataset.category === opener.dataset.systemCategory);
        this.activate(Math.max(0, index)); this.querySelector('.ka-system__catalog').scrollTop = 0;
        this.openModal(); return;
      }
      if (event.target.closest('[data-system-close]')) { event.stopPropagation(); this.closeModal(); return; }
      if (event.target === this.dialog) {
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) { event.stopPropagation(); this.closeModal(); }
        return;
      }
      const cardRow = event.target.closest('[data-system-card]');
      if (cardRow && !event.target.closest('a,button,input,select,label,option') && !cartBusy && !this.pending) {
        const choice = cardRow.querySelector('[data-system-choice]');
        if (choice && !choice.disabled) { choice.checked = !choice.checked; choice.dispatchEvent(new Event('change', { bubbles: true })); }
        return;
      }
      const viewCart = event.target.closest('[data-system-view-cart]');
      if (viewCart) {
        const drawer = document.getElementById('Cart-Drawer');
        if (typeof drawer?.open === 'function') {
          // Keep the drawer's document-level outside-click handler from closing it immediately.
          event.preventDefault(); event.stopPropagation(); this.closeModal(false); drawer.open(); return;
        }
      }
      if (event.target.closest('[data-system-cancel]') && this.pending?.retryable && !cartBusy) {
        this.pending = null; this.selection.clear(); this.message('Remaining items cleared. Items already added stay in your cart.'); this.formOwner = null; this.update(); return;
      }
      const tab = event.target.closest('[data-system-tab]');
      if (tab) this.activate(Number(tab.dataset.systemTab));
      const remove = event.target.closest('[data-system-remove]');
      if (remove && !cartBusy && !this.pending) {
        this.selection.delete(remove.dataset.systemRemove); this.update();
        (this.querySelector('[data-system-remove]') || this.tabs.find(t => t.getAttribute('aria-selected') === 'true')).focus({ preventScroll: true });
      }
      if (event.target.closest('[data-system-add]')) this.add();
    }
    change(event) {
      const card = event.target.closest('[data-system-card]'); if (!card || cartBusy || this.pending) return;
      const entry = this.cards.get(card.dataset.productId);
      if (event.target.matches('[data-system-option]')) {
        entry.variant = entry.variants.find(v => String(v.id) === event.target.value) || null;
        if (!entry.variant?.available) this.selection.delete(entry.id);
        this.updateCard(entry);
      }
      if (event.target.matches('[data-system-choice]')) {
        if (event.target.checked && entry.variant?.available) this.selection.add(entry.id); else this.selection.delete(entry.id);
      }
      this.feedbackText = ''; this.update(); this.querySelector('[data-system-feedback]').hidden = true;
    }
    updateCard(entry) {
      const { card, variant } = entry;
      const fallback = entry.variants.reduce((a, b) => a.price <= b.price ? a : b);
      const pricing = variant || fallback;
      card.querySelector('[data-system-price]').textContent = this.plain(pricing.money);
      card.querySelector('[data-system-from]').hidden = !!variant;
      card.querySelector('[data-system-club]').hidden = !pricing.club;
      card.querySelector('[data-system-regular]').hidden = !pricing.club;
      card.querySelector('[data-system-regular-money]').textContent = pricing.club ? this.plain(pricing.regularMoney) : '';
      card.querySelector('[data-system-rrp]').hidden = !(pricing.rrp > 0);
      card.querySelector('[data-system-rrp-money]').textContent = pricing.rrp > 0 ? this.plain(pricing.rrpMoney) : '';
      const saving = card.querySelector('[data-system-saving]'); saving.hidden = !pricing.showSaving;
      saving.textContent = pricing.showSaving ? `Save ${this.plain(pricing.savingMoney)}` : '';
      const status = card.querySelector('[data-system-availability]');
      if (!variant && !entry.variants.some(v => v.available)) status.textContent = 'View product for purchase options';
      else if (!variant) status.textContent = 'Choose an option to select';
      else if (!variant.available) status.textContent = 'Unavailable for quick add — view product';
      else status.textContent = variant.properties['Order Type'] || '';
      const offer = card.querySelector('[data-system-coupon]'); const coupon = variant?.coupon;
      offer.hidden = !coupon || coupon.end * 1000 <= Date.now();
      offer.textContent = coupon ? `${this.plain(coupon.money)} with code ${coupon.code}.` : '';
    }
    tick() {
      clearTimeout(this.timer); this.cards.forEach(entry => this.updateCard(entry));
      this.timer = setTimeout(() => this.tick(), 60000);
    }
    update() {
      const selected = [...this.selection].map(id => this.cards.get(id)).filter(entry => entry.variant?.available);
      this.querySelector('[data-system-total]').textContent = this.money(selected.reduce((sum, entry) => sum + entry.variant.price, 0));
      this.querySelector('[data-system-status]').textContent = selected.length ? `${selected.length} ${selected.length === 1 ? 'accessory' : 'accessories'} selected` : 'Choose your add-ons';
      this.cards.forEach(entry => {
        const checkbox = entry.card.querySelector('[data-system-choice]'); checkbox.checked = this.selection.has(entry.id); checkbox.disabled = cartBusy || !!this.pending || !entry.variant?.available;
        entry.card.classList.toggle('is-selected', checkbox.checked);
        const option = entry.card.querySelector('[data-system-option]'); if (option) option.disabled = cartBusy || !!this.pending;
      });
      this.panels.forEach((panel, i) => {
        const count = [...panel.querySelectorAll('[data-system-card]')].filter(card => this.selection.has(card.dataset.productId)).length;
        const badge = this.tabs[i].querySelector('[data-system-count]'); badge.hidden = !count; badge.textContent = String(count);
        this.tabs[i].setAttribute('aria-label', panel.dataset.categoryName + (count ? `, ${count} selected` : ''));
      });
      const list = this.querySelector('[data-system-selected]'); list.replaceChildren();
      selected.forEach(entry => {
        const li = document.createElement('li'); li.className = 'ka-system__chip'; const name = document.createElement('span'); name.textContent = entry.title;
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ka-system__remove'; button.dataset.systemRemove = entry.id; button.setAttribute('aria-label', `Remove ${entry.title}`); button.textContent = '×'; button.disabled = cartBusy || !!this.pending;
        li.append(name, button); list.append(li);
      });
      this.addButton.disabled = cartBusy || (!selected.length && !this.pending);
      this.addButton.textContent = cartBusy ? 'Updating cart…' : this.pending?.retryable ? 'Retry remaining items' : this.pending ? 'Check cart status' : selected.length ? `Add ${selected.length} add-on${selected.length === 1 ? '' : 's'}` : 'Add selected add-ons';
      const preview = this.querySelector('[data-system-preview-summary]');
      if (preview) {
        preview.textContent = this.feedbackText || (selected.length ? `${selected.length} add-on${selected.length === 1 ? '' : 's'} selected · ${this.money(selected.reduce((sum, entry) => sum + entry.variant.price, 0))}` : '');
        preview.hidden = !preview.textContent;
        this.querySelector('[data-system-open-label]').textContent = this.pending ? 'Review selection' : 'View all';
      }
      const cancel = this.querySelector('[data-system-cancel]'); if (cancel) cancel.hidden = !this.pending?.retryable || cartBusy;
      this.setAttribute('aria-busy', String(cartBusy));
    }
    message(text, error = false) { this.feedbackText = error ? text : '';  this.querySelector('[data-system-message]').textContent = text; this.querySelector('[data-system-feedback]').hidden = false; this.formOwner?.handleErrorMessage(error ? text : false); }
    async request(path, options = {}) {
      const controller = new AbortController(); const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + path, { ...options, credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json', ...options.headers } });
        return { response, data: await response.json() };
      } finally { clearTimeout(timeout); }
    }
    async readCart() {
      const { response, data } = await this.request('cart.js');
      if (!response.ok || !Array.isArray(data.items)) throw new Error('Cart unavailable'); return data;
    }
    sections() {
      const cart = document.getElementById('Cart-Drawer');
      return typeof cart?.getSectionsToRender === 'function' ? cart.getSectionsToRender() : [
        { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
        { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
      ];
    }
    async renderCart(sections) {
      const specs = this.sections(); const ids = [...new Set(specs.map(s => s.section))];
      if (!sections || ids.some(id => typeof sections[id] !== 'string')) {
        const result = await this.request(`?sections=${encodeURIComponent(ids.join(','))}`);
        if (!result.response.ok) throw new Error('Cart view unavailable'); sections = result.data;
      }
      specs.forEach(spec => {
        const target = document.getElementById(spec.id); if (!target || typeof sections[spec.section] !== 'string') return;
        const parsed = new DOMParser().parseFromString(sections[spec.section], 'text/html').querySelector(spec.selector);
        if (parsed) (target.querySelector(spec.selector) || target).innerHTML = parsed.innerHTML;
      });
      const cart = document.getElementById('Cart-Drawer');
      if (typeof cart?.open === 'function') { this.closeModal(false); cart.removeProductEvent?.(); cart.open(); }
    }
    async reconcile() {
      const pending = this.pending;
      let cart;
      try { cart = await this.readCart(); }
      catch (_) { this.message('Your cart update could not be confirmed. Check cart status or open your cart before adding again.', true); return; }
      const confirmed = confirmedLines(pending.before, cart, pending.items);
      const complete = confirmed.length === pending.items.length;
      const mainJustAdded = pending.main && !pending.mainAdded && confirmed.some(item => item.id === pending.main.variant.id && !item.properties._gwp);
      if (mainJustAdded) pending.mainAdded = true;
      const added = pending.entries.filter(entry => confirmed.some(item => item.id === entry.variant.id && !item.properties._gwp));
      added.forEach(entry => this.selection.delete(entry.id));
      const remaining = pending.entries.filter(entry => !added.includes(entry));
      if (complete || (pending.known && !pending.main)) this.pending = null;
      else {
        pending.entries = remaining;
        if (pending.known) {
          // A known partial combined add retries only missing lines, never its successful product.
          pending.items = pending.items.filter(item => !confirmed.includes(item)); pending.retryable = true;
        }
      }
      try { await this.renderCart(pending.sections); }
      catch (_) { /* Confirmed additions stay cleared even if cart rendering fails. */ }
      if (added.length || mainJustAdded) document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { source: 'complete-your-system', coreProductAdded: !!mainJustAdded, productVariantId: mainJustAdded ? pending.main.variant.id : null, product: cart.items.find(line => String(line.variant_id) === String(mainJustAdded ? pending.main.variant.id : added[0].variant.id)), items: [...(mainJustAdded ? [pending.main.variant.id] : []), ...added.map(entry => entry.variant.id)] } }));
      if (complete) this.message(pending.main ? 'Your product and selected add-ons have been added to your cart.' : 'Your selected accessories have been added to your cart.');
      else if (!pending.known) this.message('Some additions could not be confirmed. Open your cart or check cart status before adding again.', true);
      else if (pending.main) this.message(`${pending.mainAdded ? 'Your product is in the cart. ' : ''}${pending.error || 'Some items could not be added.'} Retry to add only the remaining items.`, true);
      else if (remaining.length) this.message(`${added.length ? `${added.length} added. ` : ''}${pending.error || 'Some accessories could not be added.'} Review the remaining selections and try again.`, true);
      else this.message('Accessories added. Please review your cart; some included items could not be confirmed.', true);
    }
    async add(main = null, owner = null) {
      if (cartBusy) return;
      const entries = [...this.selection].map(id => this.cards.get(id)).filter(entry => entry.variant?.available);
      if (!this.pending && !entries.length) return;
      this.formOwner = owner || this.formOwner;
      const buttons = this.formOwner ? [...this.formOwner.form.elements].filter(el => el.matches('button[name="add"]')) : [];
      buttons.forEach(button => { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); });
      cartBusy = true; instances.forEach(instance => instance.update());
      try {
        if (!this.pending || this.pending.retryable) {
          let before;
          try { before = await this.readCart(); }
          catch (_) { this.message('Your cart could not be read. Please try again before adding items.', true); return; }
          if (!this.pending) {
            const items = buildItems(main ? [main, ...entries] : entries, window.KaGwpCart?.prepareAddFormData);
            this.pending = { before, items, entries, main, mainAdded: false, known: false, sections: null, error: '' };
          } else Object.assign(this.pending, { before, retryable: false, known: false, sections: null, error: '' });
          try {
            const sections = [...new Set(this.sections().map(s => s.section))];
            const payload = this.pending.main ? { headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: batchFormData(this.pending.items, sections) } : { headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: this.pending.items, sections, sections_url: window.location.pathname }) };
            const result = await this.request('cart/add.js', { method: 'POST', ...payload });
            this.pending.known = true; this.pending.sections = result.data.sections;
            if (!result.response.ok || result.data.status) this.pending.error = typeof result.data.description === 'string' ? result.data.description.slice(0, 300) : 'Some items could not be added.';
          } catch (_) { /* An uncertain POST must be reconciled, never blindly retried. */ }
        }
        await this.reconcile();
      } finally {
        cartBusy = false; instances.forEach(instance => instance.update());
        buttons.forEach(button => { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); });
        if (!this.pending) this.formOwner = null;
      }
    }
  }
  // Both native PDP and sticky buttons submit the same product form. Leave other products and empty selections on the native path.
  window.KaCompleteSystem = {
    handlesUpsell(detail) { return [...instances].some(instance => matchesCoreAdd(instance, detail)); },
    submit(owner) {
      const form = new FormData(owner.form), variantId = String(form.get('id'));
      const system = [...instances].find(instance => (instance.dataset.variantIds || '').split(',').includes(variantId) && (instance.selection.size || instance.pending || cartBusy));
      if (!system) return false;
      owner.handleErrorMessage();
      try { system.add(mainEntry(form), owner).catch(error => owner.handleErrorMessage(error.message || 'Please check your cart before adding again.')); }
      catch (error) { owner.handleErrorMessage(error.message); }
      return true;
    }
  };
  document.addEventListener('cart:item-added', event => {
    const system = [...instances].find(instance => matchesCoreAdd(instance, event.detail));
    if (!system) return;
    document.getElementById('Cart-Drawer')?.close?.();
    system.afterCoreAdd = true; system.activate(0);
    system.message('Your product has been added to your cart. Choose add-ons or view your cart.');
    system.openModal();
  });
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach(instance => {
      if (instance.sourceSection === event.target && !event.target.contains(instance)) { instance.suppressRestore = true; instance.remove(); }
    });
  });
  document.addEventListener('shopify:section:load', () => {
    instances.forEach(instance => {
      const placement = [...document.querySelectorAll('[data-system-placement]')].find(el => el.dataset.systemProductId === instance.dataset.systemProductId);
      if (placement && instance.parentElement !== placement) placement.append(instance);
    });
  });
  customElements.define('ka-complete-system', CompleteSystem);
})();
